/**
 * Returns the inclusive range of row ids between `anchorId` and `targetId` within `orderedRowIds`,
 * regardless of which comes first. Used by shift-click range checking. If either id is not present
 * in the ordered list, no range can be resolved.
 */
export function getRangeBetween(
  orderedRowIds: readonly string[],
  anchorId: string,
  targetId: string,
): readonly string[] | null {
  const anchorIndex = orderedRowIds.indexOf(anchorId);
  const targetIndex = orderedRowIds.indexOf(targetId);

  if (anchorIndex === -1 || targetIndex === -1) {
    return null;
  }

  const [start, end] = anchorIndex <= targetIndex ? [anchorIndex, targetIndex] : [targetIndex, anchorIndex];
  return orderedRowIds.slice(start, end + 1);
}
